"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Dropdown;
var _react = _interopRequireDefault(require("react"));
var _item = _interopRequireDefault(require("../../item"));
var _ = require("../..");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function Dropdown(props) {
  var item = props.item;
  var active = item.render.params.children.some(function (child) {
    return (0, _.isActive)(_objectSpread(_objectSpread({}, props), {}, {
      item: child
    }));
  }) ? 'active' : '';
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: "dropdown ".concat(active)
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: item.url,
    "data-target": "#",
    className: "dropdown-toggle dd nav-drop-down",
    "data-toggle": "dropdown",
    "aria-haspopup": "true",
    "aria-expanded": "false"
  }, /*#__PURE__*/_react["default"].createElement("span", null, item.render.params.label, " ", /*#__PURE__*/_react["default"].createElement("span", {
    className: "caret"
  }))), /*#__PURE__*/_react["default"].createElement("ul", {
    className: "dropdown-menu menu"
  }, item.render.params.children.map(function (child, index) {
    return /*#__PURE__*/_react["default"].createElement(_item["default"], {
      key: index,
      item: child,
      active: (0, _.isActive)(_objectSpread(_objectSpread({}, props), {}, {
        item: child
      }))
    });
  })));
}